const summaryUiModel = {
  password: {
    isValid: (val, rulesValidation) => {
      return rulesValidation?.every((el) => el.isValid(val))
    },
    value: '',
    complement: 'confirmationPassword',
    errors: [],
    validations: [
      {
        name: 'QTY_CHARS',
        isValid: (elm) => /^\S{6,8}$/g.test(elm),
      },
      {
        name: 'ONLY_ALPHANUMERIC',
        // isValid: (elm) => /^[a-zA-Z0-9]+$/i.test(elm),
        isValid: (elm) => /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/.test(elm),
        // isValid: (elm) => /^(?=.*[A-Za-z])(?=.*\d)/.test(elm),
      },
      {
        name: 'CONTAIN_UPPERCASE_L0WERCASE',
        isValid: (elm) => /^(?=.*[a-z])(?=.*[A-Z])/.test(elm),
      },
      /* {
        name: 'CONTAIN_NUMBER',
        isValid: (elm) => /\d/.test(elm),
      }, */
    ],
  },
  confirmationPassword: {
    isValid: (elm) => /^[a-zA-Z0-9]+$/.test(elm),
    value: '',
    complement: 'password',
    errors: [],
  },
  inputCodeSMS: {
    isValid: (elm, disabled = false) => elm.every((v) => v.length === 1 && v !== '' && !disabled),
    errors: [],
    value: ['', '', '', '', '', ''],
    secondsAvailableToRespond: 120,
    disabled: false,
  },
};

export default summaryUiModel;
